import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import store from "./store.js"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "./main.js"
import "./index.css"

const container = document.getElementById("root")
const root = createRoot(container)

let persistor = persistStore(store)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    ,
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
